import MAIN from './module/main';
import HOME from './module/home';
import CASE from './module/case';
import topics from './pages/home/topics';
import contact from './module/contact';
import SALES from './module/sales';

const app = () => {
  MAIN();

  switch( location.pathname.replace(/^(\/[^/]+)\/([^/]+\/)?(.*)?$/,'$1/$2') ){
    case '/': HOME(); break;
    case '/case/': CASE(); break;
    case '/topics/': topics(); break;
    case '/contact/': contact(); break
    case '/reserve/': contact(); break
  }

  // case詳細ページ
  if ( /^\/case\/.+$/.test(location.pathname) ) contact();

  // event詳細ページ
  if ( /^\/events\/.+$/.test(location.pathname) ) contact();

  // sales詳細ページ
  if ( /^\/sales\/.+$/.test(location.pathname) ) SALES();
}

document.addEventListener('DOMContentLoaded', app);
